/*------------------------------------*\
    MODULES
\*------------------------------------*/
import 'whatwg-fetch';

/*------------------------------------*\
    SITE NAV
\*------------------------------------*/
class NewsPagination {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;

        self.trigger = self.elem.querySelector('.js-pagination__trigger');

        self.target = self.elem.querySelector('.js-pagination__target');

        self.url = self.elem.getAttribute('data-url');
        self.channel = self.elem.getAttribute('data-channel');

        // State
        self.state = {
            remaining_count: 0,
            offset: 6,
            limit: parseInt(self.elem.getAttribute('data-limit'), 10),
            isDisabled: false
        };

        self.settings = {
            hiddenClass: 'd-none',
            mutedClass: 'is-muted'
        }
    }

    init() {
        let self = this;

            // Bail out if no trigger
            if(self.trigger === null) return;

            self.trigger.addEventListener('click', (evt) => {
                evt.preventDefault();


                if(self.state.isDisabled) return;

                self.fetch();
            });

    }

    fetch() {
        let self = this;

        self.state.offset = self.state.offset += self.state.limit;

        self.setTriggerState('disabled');

        // Fetch the marker data
        fetch(`${self.url}?${ self.toQueryString({
            offset: self.state.offset,
            limit: self.state.limit,
            channel: self.channel
        })}`)
        .then(function(response) {

            if(response.status !== 200) {
                throw new Error(`Error received from '${ self.url }': Code ${ response.status }`);
            }

            if(!response.json) {
                throw new Error('No data sent back from ajax endpoint');
            }

            // Data is valid so pass along
            return response.json();

        })
        .then(function(json) {

            // Set the target content
            self.target.innerHTML += json.body;

            // Set the remaining count
            self.state.remaining_count = json.remaining_count;

            // Run any post-fetch actions
            self.postFetch();

            // Re-enable the trigger
            self.setTriggerState('enabled');

        })
        .catch(function(ex) {
            self.setTriggerState('enabled');
            throw new Error(ex);
        });
    }

    // Deal with any display logic and state manipulation after a request
    postFetch() {
        let self = this;
        let mutedItems = [...self.target.querySelectorAll(`.${ self.settings.mutedClass }`)];

        console.log(self.state.remaining_count);
        if(self.state.remaining_count <= 0) {
            self.setTriggerState('hidden');
        }

        if(mutedItems.length) {

            setTimeout(() => {
                mutedItems.map(item => { item.classList.remove(self.settings.mutedClass) });
            }, 100);
        }

    }

    setTriggerState(state = 'disabled') {
        let self = this;

            switch(state) {

                case 'disabled':
                    self.trigger.setAttribute('disabled', 'true');
                    self.trigger.classList.add(self.settings.mutedClass);
                    break;

                case 'enabled':
                    self.trigger.removeAttribute('disabled');
                    self.trigger.classList.remove(self.settings.mutedClass);
                    break;

                case 'hidden':
                    self.trigger.setAttribute('disabled', 'true');
                    self.trigger.classList.add(self.settings.hiddenClass);
                    break;
            }



    }

    // Convert an object literal to a query string
    toQueryString(paramsObject) {
        return Object
            .keys(paramsObject)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`)
            .join('&');
    }
}

export default NewsPagination;
